import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useModalOutsideClick from '../../hooks/useModalOutsideClick';
import './ViewCurrentChipCounts.css';
import { formatNumber } from '../../../../utils/helpers';

const ViewCurrentChipCounts = ({
  show,
  onClose,
  players,
  currentUsername
}) => {
  // Add the useModalOutsideClick hook to close when clicking outside
  useModalOutsideClick(show, onClose, "view-chip-counts-overlay");

  // Filter and sort players with chip counts
  const sortedPlayers = useMemo(() => {
    if (!players) return [];
    
    return players
      .filter(player => player.sportSpecificData?.currentChipCount > 0)
      .sort((a, b) => {
        const countA = a.sportSpecificData?.currentChipCount || 0;
        const countB = b.sportSpecificData?.currentChipCount || 0;
        return countB - countA; // Sort descending
      });
  }, [players]);

  if (!show) return null;

  return (
    <div className="view-chip-counts-overlay">
      <div className="view-chip-counts-dialog">
        <div className="view-chip-counts-header">
          <h3>Current Chip Counts</h3>
          <button className="view-chip-counts-close-button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="view-chip-counts-content">
          {sortedPlayers.length > 0 ? (
            <table className="chip-counts-table">
              <thead>
                <tr>
                  <th>PLAYER</th>
                  <th>CHIPS</th>
                </tr>
              </thead>
              <tbody>
                {sortedPlayers.map((player) => {
                  const isCurrentUser = player.name.toLowerCase() === currentUsername?.toLowerCase();
                  return (
                    <tr 
                      key={player.name}
                      className={isCurrentUser ? 'current-user-row' : ''}
                    >
                      <td className="player-name">{player.name}</td>
                      <td className="chip-count">
                        {formatNumber(player.sportSpecificData.currentChipCount)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p className="no-chip-counts-message">No active chip counts available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

ViewCurrentChipCounts.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  players: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      sportSpecificData: PropTypes.shape({
        currentChipCount: PropTypes.number
      })
    })
  ).isRequired,
  currentUsername: PropTypes.string
};

export default ViewCurrentChipCounts; 